// ****************************************************************
// Definition globale Variablen
// ****************************************************************

export default {
  error: {
    show: false,
    nachricht: '',
    error: ''
  },
  beta: false,
  version: 'v.1.0.33',
  versionDatum: '2023-04-01',
  verbindung: '',
  loading: false,
  settings: {}
}



// WEBPACK FOOTER //
// ./src/main_variablen.js